import { useEffect } from "react";
import { Logo } from "@/components/landing/Brand";
import { Footer } from "@/components/landing/Footer";

const SRC = process.env.REACT_APP_HOLO_BLOG_EMBED_URL;

export default function Blog() {
  useEffect(() => {
    if (!SRC) return undefined;
    const s = document.createElement("script");
    s.src = `${SRC}?t=${Date.now()}`;
    s.defer = true;
    document.body.appendChild(s);
    return () => { s.remove(); };
  }, []);

  return (
    <main className="min-h-screen bg-[#F7F9FC] flex flex-col" data-testid="blog-page">
      <header className="bg-white/80 backdrop-blur-xl border-b border-slate-200/70">
        <div className="max-w-7xl mx-auto px-5 sm:px-10 h-[72px] flex items-center justify-between">
          <Logo href="/" testId="blog-nav-logo" />
          <a href="/#signup" data-testid="blog-nav-waitlist-btn" className="rounded-full bg-[#2F7FF0] text-white text-sm font-bold px-5 py-2.5 hover:bg-[#13296B] transition-colors duration-300">Get early access</a>
        </div>
      </header>
      <section className="flex-1 max-w-5xl w-full mx-auto px-5 sm:px-10 py-14 sm:py-20">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#2F7FF0]">Marketgetr blog</p>
        <h1 className="font-display text-4xl sm:text-6xl font-extrabold tracking-tight text-[#13296B] mt-4 mb-10">News, tips and driver stories</h1>
        <div id="holo-blog" data-testid="holo-blog-embed" />
      </section>
      <Footer home={false} />
    </main>
  );
}
